export class TrainingSessionStudent {
    constructor(
        public id?: number,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public price?: number,
        public displayedPrice?: string,
        public registrationDetailId?: number,
        public selected?: boolean,
        public editingMode?: string,
        public conventionSent?: boolean,
        public mailSent?: boolean,
        public title?: string,
        public companyId?: number,
        public contactId?: number
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/session/company/contact/student/training-session-student.model.ts